export default __webpack_public_path__ + "static/media/external-link.7ba2be95.svg";